<template>
    <div
        :class="isMove ? 'stamp-move' : ''"
        style="position: absolute" :style="positionStyle" @click="onClick">
        <img
            :key = width
            ref  = "image"
            v-if = "image"
            :src = "image"
            alt  = ""
            style="max-height: 100%; max-width: 100%"
        />
    </div>

</template>

<script>

export default {
    name: "IncDragStamp",

    props: {
        image: {
            required: true
        },

        width: {

        }
    },

    data: () => ({
        x: 200,
        y: 200,
        initX: 0,
        initY: 0,
        isMove: false
    }),

    mounted() {
        this.$el.parentElement.addEventListener('mousemove', this.drag, { passive: false })
    },

    beforeDestroy () {
        this.$el.parentElement.removeEventListener('mousemove', this.drag, { passive: false })
    },

    computed: {
        positionStyle () {
            return {
                width: `${this.width}px`,
                left: `${this.x}px`,
                top: `${this.y}px`,
                cursor: this.isMove ? 'move' : 'auto',
            }
        },

    },

    methods: {
        size () {
            return {
                height: this.$refs.image.clientHeight,
                width : this.$refs.image.clientWidth,
            };
        },

        onClick (e) {
            if (!this.isMove) {
                this.initX = e.pageX - this.$el.offsetLeft
                this.initY = e.pageY - this.$el.offsetTop
            } else {
                this.$emit("position", {
                    x: this.x,
                    y: this.y
                })
            }

            this.isMove = !this.isMove;
        },

        drag (e) {
            if ( this.isMove) {
                let x = e.pageX - this.initX
                let y = e.pageY - this.initY

                let height = this.$el.parentElement.offsetHeight;
                let width  = this.$el.parentElement.offsetWidth;

                width -= this.$el.offsetWidth/2
                height -= this.$el.offsetHeight/2

                x = x > width ? width : x
                x = x < 0 ? 0 : x
                y = y > height ? height : y
                y = y < 0 ? 0 : y

                this.x = x
                this.y = y
            }
        },
    }
}
</script>

<style scoped>

.stamp-move {
    border-style: dotted;
    border-width: 1px;
    border-color: lightgray;
}

</style>